import React, { useEffect, useState } from "react";
// import "antd/dist/antd.css";
import moment from "moment";
import { Modal, Progress } from "antd";
// import { useAppContext } from "../../../../lib/AppContext";
import { functionService } from "../../../../lib/functions";
import { progressBarColor } from "../../../../utils/commonFunctions";
import VideoPlayer from "../../../../components/videoPlayer";
import * as Styled from "./styles/viewDetailsModalStyled";
import CoffeeeButton from "../../../../components/uiKit/button";
import AssessmentPdfView from "../../../../components/candidateAssessmentPdf/index";
export const StudentDetailsCardWithVideos = ({
  studentId,
  recruiter_id,
  theme,
  style,
}) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [studentDetails, setStudentDetails] = useState({});
  const [showCertificate, setShowCertificate] = useState(false);
  const [modalWidth, setModalWidth] = useState('72vw');
  // console.log(useAppContext());

  // useEffect(() => {
  //   if (contentWidth < 992) {
  //     setModalWidth('90vw');
  //   }
  // }, [contentWidth]);

  const getCandidateDetails = async () => {
    if (typeof studentId !== 'undefined' && loading === false) {
      setLoading(true);

      const { status, response } = await functionService.get(
        `recruiter/candidate-details/${recruiter_id}/${studentId}`
      );

      // console.log('====================>', response)

      if (status) {
        setOpen(true);

        const studentDetail = {
          ...response?.data?.data[0],
          technicalSkills: response?.data?.data[0]?.technicalSkills ? response?.data?.data[0]?.technicalSkills.filter(
            ({ top_percentile }) => typeof top_percentile !== 'undefined' && top_percentile !== null
          ) : [],
          softSkills: response?.data?.data[0]?.softSkills ? response?.data?.data[0]?.softSkills.filter(
            ({ top_percentile }) => typeof top_percentile !== 'undefined' && top_percentile !== null
          ) : [],
          // mcqCodingVideo: response?.data?.data[0]?.mcqCodingVideo ? response?.data?.data[0]?.mcqCodingVideo.filter(
          //   ({ screenrecording_url }) => isValid(screenrecording_url)
          // ) : [],
          // projectInterviewVideo: response?.data?.data[0]?.projectInterviewVideo ? response?.data?.data[0]?.projectInterviewVideo.filter(
          //   ({ screenrecording_url }) => isValid(screenrecording_url)
          // ) : [],
          // screenInterviewVideo: response?.data?.data[0]?.screenInterviewVideo ? response?.data?.data[0]?.screenInterviewVideo.filter(
          //   ({ screenrecording_url }) => isValid(screenrecording_url)
          // ) : [],
        };

        setStudentDetails(studentDetail);
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  };

  const isValid = (value) => {
    if (typeof value !== 'undefined' && value !== null && value !== '') {
      return true;
    } else {
      return false;
    }
  }

  const calculateTotalExp = (expMonth) => {
    let totalMonth = 0;
    let totalYear = 0;
    if (expMonth) {
      totalYear = Math.floor(expMonth / 12);
      totalMonth = expMonth % 12;
    }
    const totalYearRender = `${totalYear > 1
      ? `${totalYear} yrs`
      : `${totalYear} yr`
      }`;
    const totalMonthRender = `${totalMonth > 1
      ? `${totalMonth} mos`
      : `${totalMonth} mo`
      }`;
    return totalYear > 0
      ? `${totalYearRender} ${totalMonthRender}`
      : `${totalMonthRender <= 0 ? "0 Month" : totalMonthRender}`
  };
  return (
    <>
      <Modal
        width={modalWidth}
        bodyStyle={{ height: "72vh", overflow: "auto" }}
        className={`studentDetails`}
        open={open}
        header={false}
        footer={false}
        onCancel={() => setOpen(false)}
        destroyOnClose
      >
        <Styled.InnerContainerDiv>
          <Styled.InfoWrapDiv>
            <Styled.DesktopProfileImg src={studentDetails?.profile_image} />

            <Styled.InfoDiv>
              <div style={{ display: 'flex' }}>
                <Styled.MobileProfileImg src={studentDetails?.profile_image} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Styled.NameH3>{studentDetails?.name}</Styled.NameH3>
                  <Styled.LocationP>
                    { studentDetails?.location && (
                      <div style={{display: 'flex'}}>
                        <img src="/location.svg" />
                        <p style={{margin: '5px'}}>{studentDetails?.location}</p>
                      </div>
                    )}
                  </Styled.LocationP>
                </div>
              </div>

              { studentDetails.is_shortlisted && isValid(studentDetails.aboutme) ?
                <Styled.DescriptionDiv>{studentDetails.aboutme}</Styled.DescriptionDiv>
              : ''
              }

              <Styled.DescWrapDiv>
                { studentDetails.is_shortlisted && isValid(studentDetails?.phone) ?
                  <div>
                    <div>Contact No</div>
                    <div>{studentDetails.phone}</div>
                  </div>
                : ''
                }
                { studentDetails.is_shortlisted && isValid(studentDetails?.email) ?
                  <div>
                    <div>Email Address</div>
                    <div>{studentDetails.email}</div>
                  </div>
                : ''
                }
                { studentDetails.is_shortlisted && isValid(studentDetails?.college) ?
                  <div>
                    <div>College</div>
                    <div style={{width: '60%'}}>{studentDetails?.college ? studentDetails?.college : "-"}</div>
                  </div>
                : ''
                }
                { studentDetails.is_shortlisted && isValid(studentDetails?.degree) ?
                  <div>
                    <div>Degree</div>
                    <div>{studentDetails?.college ? studentDetails?.degree : "-"}</div>
                  </div>
                : ''
                }
                { studentDetails.is_shortlisted && isValid(studentDetails?.company_name) ?
                  <div>
                    <div>Current Company</div>
                    <div>{studentDetails?.company_name ? studentDetails?.company_name : "-"}</div>
                  </div>
                : ''
                }
                { studentDetails?.available_on && isValid(studentDetails?.available_on) ?
                  <div>
                    <div>Available on</div>
                    <div>{studentDetails?.available_on ? moment(studentDetails?.available_on).format("MMMM Do YYYY") : '-'}</div>
                  </div>
                : ''
                }
                { isValid(studentDetails?.experience_month) ?
                  <div>
                    <div>Experience</div>
                    <div>{calculateTotalExp(studentDetails.experience_month)}</div>
                  </div>
                : ''
              }
              { studentDetails.current_salary && isValid(studentDetails?.current_salary) ?
                <div>
                  <div>Current CTC</div>
                  <div>{studentDetails?.current_salary || "-"}</div>
                </div>
              : ''
              }
              { studentDetails.current_salary && isValid(studentDetails?.expected_salary) ?
                <div>
                  <div>Expected CTC</div>
                  <div>{studentDetails?.expected_salary || "-"}</div>
                </div>
              : ''
              }
              { studentDetails.current_salary && isValid(studentDetails?.notice_period) ?
                <div>
                  <div>Notice Period</div>
                  <div>{studentDetails?.notice_period || "-"}</div>
                </div>
              : ''
              }
              { studentDetails.current_salary && isValid(studentDetails?.otherskills) ?
                <div>
                  <div>Other Skills</div>
                  <div>{studentDetails?.otherskills || '-'}</div>
                </div>
              : ''
              }
              </Styled.DescWrapDiv>
            </Styled.InfoDiv>
          </Styled.InfoWrapDiv>

          { studentDetails?.technicalSkills
          && studentDetails?.technicalSkills.length > 0 ?
            <Styled.SkillsOuterDiv>
              <Styled.SkillsDescDiv>
                <div>Technical Skills</div>
                <div>These scores are the result of technical assessment the candidate has undergone. These would include multiple choice and coding problems.</div>
              </Styled.SkillsDescDiv>

              <Styled.SkillsDiv>
                <Styled.SkillsHeadDiv>
                  <div>Skills</div>
                  <div>Assessment Result</div>
                </Styled.SkillsHeadDiv>

                { studentDetails?.technicalSkills.map(tSkill => (
                  <Styled.SkillDetailsDiv>
                    <div>{tSkill.skills}</div>
                    <Progress
                      strokeColor={progressBarColor(tSkill.percentile)}
                      percent={tSkill.percentile}
                      showInfo={false}
                    />
                    <div>{tSkill.top_percentile ? `Top ${tSkill.top_percentile}%` : ''}</div>
                  </Styled.SkillDetailsDiv>
                )) }
              </Styled.SkillsDiv>
            </Styled.SkillsOuterDiv>
          : ''
          }

          { studentDetails?.softSkills
          && studentDetails?.softSkills.length > 0 ?
            <Styled.SkillsOuterDiv>
              <Styled.SkillsDescDiv>
                <div>Soft Skills</div>
                <div>English Language and Logical reasoning assessments have multiple choice questions randomly chosen out of a large pool.</div>
              </Styled.SkillsDescDiv>

              <Styled.SkillsDiv>
                <Styled.SkillsHeadDiv>
                  <div>Skills</div>
                  <div>Assessment Result</div>
                </Styled.SkillsHeadDiv>

                { studentDetails?.softSkills.map(tSkill => (
                  <Styled.SkillDetailsDiv>
                    <div>{tSkill.skills}</div>
                    <Progress
                      strokeColor={progressBarColor(tSkill.percentile)}
                      percent={tSkill.percentile}
                      showInfo={false}
                    />
                    <div>{tSkill.top_percentile ? `Top ${tSkill.top_percentile}%` : ''}</div>
                  </Styled.SkillDetailsDiv>
                )) }
              </Styled.SkillsDiv>
            </Styled.SkillsOuterDiv>
          : ''
          }
          { studentDetails.otherskills ?
            <Styled.SkillsOuterDiv>
              <Styled.SkillsDescDiv>
                <div>Other Skills</div>
                <div>These are other technical skills specified by the candidate in their profile.</div>
              </Styled.SkillsDescDiv>

              <Styled.SkillsDiv>
                <Styled.SkillsHeadDiv>
                  <div>Skills</div>
                </Styled.SkillsHeadDiv>
                  <Styled.OtherSkillsDiv>
                    <div>{studentDetails.otherskills}</div>
                  </Styled.OtherSkillsDiv>

              </Styled.SkillsDiv>
            </Styled.SkillsOuterDiv>
          : ''
          }

          { studentDetails?.mcqCodingVideo && studentDetails?.mcqCodingVideo.length > 0 ?
            <Styled.VideoWrapDiv>
              <Styled.HeadingP>Assessment History - Live Recordings</Styled.HeadingP>
              <Styled.VideoDescDiv>You will be able to view the complete recording of the candidate’s assessments. This way you can also check his approach to problem solving and not just depend on the final output.</Styled.VideoDescDiv>

              { studentDetails?.mcqCodingVideo?.map((videoDetails) => {
                return (
                  <Styled.VideoAssessmentDiv>
                    <Styled.VideoDetailsDiv>

                      <Styled.VideoNameDiv>{videoDetails.test_title}</Styled.VideoNameDiv>

                      <Styled.InnerDetailsDiv>
                        <Styled.DetailsDiv>
                          <Styled.Label2>Skill :</Styled.Label2>
                          <Styled.Details2>{videoDetails.skill_name} </Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Duration :</Styled.Label2>
                          <Styled.Details2>{`${videoDetails.duration} Min.`}</Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Marks :</Styled.Label2>
                          <Styled.Details2>{videoDetails.total_marks}</Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Score :</Styled.Label2>
                          <Styled.Details2>{`${videoDetails.candidate_marks}/${videoDetails.total_marks}`}</Styled.Details2>
                        </Styled.DetailsDiv>
                  {videoDetails?.assessment_id&&   <AssessmentPdfView id={videoDetails?.assessment_id} skills={studentDetails?.technicalSkills} recruiter_id={recruiter_id}  />}
                      </Styled.InnerDetailsDiv>
                    </Styled.VideoDetailsDiv>
                    {/* { videoDetails.screenrecording_url !== null && */}
                      <Styled.VideoPlayerDiv>
                      { open === true?
                        <VideoPlayer
                          duration={videoDetails.recording_duration}
                          thumbnail="/recordingThumbNail.png"
                          url={`${videoDetails.screenrecording_url}`}
                        />
                      : ''
                      }
                      {videoDetails.screenrecording_url === null ? <p style={{color: 'red'}}>Video not available</p> : ''}
                      </Styled.VideoPlayerDiv>

                    {/* } */}
                  </Styled.VideoAssessmentDiv>
                );
              })}
            </Styled.VideoWrapDiv>
          : ''
          }

          { studentDetails?.projectInterviewVideo && studentDetails?.projectInterviewVideo.length > 0 ?
            <Styled.VideoWrapDiv>
              <Styled.HeadingP>Project Work</Styled.HeadingP>
              <Styled.VideoDescDiv>This section has the complete recording of candidate’s approach to the project work.</Styled.VideoDescDiv>

              { studentDetails?.projectInterviewVideo?.map((videoDetails) => {
                return (
                  <Styled.VideoAssessmentDiv>
                    <Styled.VideoDetailsDiv>

                      <Styled.VideoNameDiv>{videoDetails.test_title}</Styled.VideoNameDiv>

                      <Styled.InnerDetailsDiv>
                        <Styled.DetailsDiv>
                          <Styled.Label2>Skill :</Styled.Label2>
                          <Styled.Details2>{videoDetails.skill_name} </Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Duration :</Styled.Label2>
                          <Styled.Details2>{`${videoDetails.duration} Min.`}</Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Marks :</Styled.Label2>
                          <Styled.Details2>{videoDetails.total_marks}</Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Score :</Styled.Label2>
                          <Styled.Details2>{`${videoDetails.candidate_marks}/${videoDetails.total_marks}`}</Styled.Details2>
                        </Styled.DetailsDiv>
                      </Styled.InnerDetailsDiv>

                      { isValid(videoDetails.project_link) ?
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <a href={videoDetails.project_link}>Download</a>
                          <Styled.VideoDescDiv style={{ padding: '8px 0px 0px 0px' }}>You can download the complete code & run it locally to check the output.</Styled.VideoDescDiv>
                        </div>
                      : ''
                      }
                    </Styled.VideoDetailsDiv>

                    <Styled.VideoPlayerDiv>
                    { open === true ?
                        <VideoPlayer
                          duration={videoDetails.recording_duration}
                          thumbnail="/thumbnail-project.png"
                          url={`${videoDetails.screenrecording_url}`}
                        />
                      : ''
                    }
                    </Styled.VideoPlayerDiv>
                  </Styled.VideoAssessmentDiv>
                );
              })}
            </Styled.VideoWrapDiv>
          : ''
          }

          { studentDetails?.screenInterviewVideo && studentDetails?.screenInterviewVideo.length > 0 ?
            <Styled.VideoWrapDiv>
              <Styled.HeadingP>Screening Interview</Styled.HeadingP>
              <Styled.VideoDescDiv>Here you can see how the candidate answers some real interview questions. It will give you an insight into his communication skills, his ability to handle pressure and details of his past experiences. Makes the hiring decision real easy.</Styled.VideoDescDiv>

              { studentDetails?.screenInterviewVideo?.map((videoDetails) => {
                return (
                  <Styled.VideoAssessmentDiv>
                    <Styled.VideoDetailsDiv>

                      <Styled.VideoNameDiv>{videoDetails.test_title}</Styled.VideoNameDiv>

                      <Styled.InnerDetailsDiv>
                        <Styled.DetailsDiv>
                          <Styled.Label2>Skill :</Styled.Label2>
                          <Styled.Details2>{videoDetails.skill_name} </Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Duration :</Styled.Label2>
                          <Styled.Details2>{`${videoDetails.duration} Min.`}</Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Marks :</Styled.Label2>
                          <Styled.Details2>{videoDetails.total_marks}</Styled.Details2>
                        </Styled.DetailsDiv>

                        <Styled.DetailsDiv>
                          <Styled.Label2>Score :</Styled.Label2>
                          <Styled.Details2>{`${videoDetails.candidate_marks}/${videoDetails.total_marks}`}</Styled.Details2>
                        </Styled.DetailsDiv>
                      </Styled.InnerDetailsDiv>
                    </Styled.VideoDetailsDiv>

                    <Styled.VideoPlayerDiv>
                      { open === true ?
                        <VideoPlayer
                          duration={videoDetails.recording_duration}
                          thumbnail="/thumbnail-screening.png"
                          url={`${videoDetails.screenrecording_url}`}
                        />
                      : ''
                      }
                    </Styled.VideoPlayerDiv>
                  </Styled.VideoAssessmentDiv>
                );
              })}
            </Styled.VideoWrapDiv>
          : ''
          }

          { studentDetails.workExperience && studentDetails.workExperience.length > 0 ?
            <Styled.VideoWrapDiv>
              <Styled.HeadingP>Work Experience</Styled.HeadingP>

              { studentDetails.workExperience.map(edu => (
                <Styled.EducationWrapDiv>
                  <Styled.EducationImageDiv>
                    <img src={isValid(edu.company_logo) ? edu.company_logo : '/experience-icon.svg'} />
                  </Styled.EducationImageDiv>
                  <Styled.EducationDiv>
                    <Styled.NameDiv>{edu.designation}</Styled.NameDiv>
                    <Styled.SubnameDiv>{edu.company_name}</Styled.SubnameDiv>
                    { isValid(edu.start_date) ?
                      <Styled.SubnameDiv>
                        {`${moment(edu.start_date).format("MMM YYYY")} - ${isValid(edu.end_date) ? moment(edu.end_date).format("MMM YYYY") : 'Present'}`}
                      </Styled.SubnameDiv>
                    : ''
                    }
                  </Styled.EducationDiv>
                </Styled.EducationWrapDiv>
              )) }
            </Styled.VideoWrapDiv>
          : ''
          }

          { studentDetails.eductionData && studentDetails.eductionData.length > 0 ?
            <Styled.VideoWrapDiv>
              <Styled.HeadingP>Education</Styled.HeadingP>

              { studentDetails.eductionData.map(edu => (
                <Styled.EducationWrapDiv>
                  <Styled.EducationImageDiv>
                    <img src={isValid(edu.university_logo) ? edu.university_logo : '/university-icon.svg'} />
                  </Styled.EducationImageDiv>
                  <Styled.EducationDiv>
                    <Styled.NameDiv>{edu.university_name}</Styled.NameDiv>
                    <Styled.SubnameDiv>{edu.degree_name}</Styled.SubnameDiv>
                    { isValid(edu.start_year) && isValid(edu.end_year) ?
                      <Styled.SubnameDiv>{`${edu.start_year.split('-')[0]} - ${edu.end_year.split('-')[0]}`}</Styled.SubnameDiv>
                    : ''
                    }
                    { isValid(edu.grades) ?
                      <Styled.SubnameDiv>{`Grades: ${edu.grades}`}</Styled.SubnameDiv>
                    : ''
                    }
                  </Styled.EducationDiv>
                </Styled.EducationWrapDiv>
              )) }
            </Styled.VideoWrapDiv>
          : ''
          }

          { studentDetails.projects && studentDetails.projects.length > 0 ?
            <Styled.VideoWrapDiv>
              <Styled.HeadingP>Projects</Styled.HeadingP>
              { studentDetails.projects.map(pro => (
                <>
                  <Styled.NameDiv>{pro.project_name}</Styled.NameDiv>
                  { isValid(pro.start_date) ?
                    <Styled.SubnameDiv>
                      {`${moment(pro.start_date).format("MMM YYYY")} - ${isValid(pro.end_date) ? moment(pro.end_date).format("MMM YYYY") : 'Present'}`}
                    </Styled.SubnameDiv>
                  : ''
                  }

                  { isValid(pro.project_url) ?
                    <Styled.ViewDemoA href={pro.project_url} target="_blank">View Project</Styled.ViewDemoA>
                  : ''
                  }

                  <Styled.VideoDescDiv>{pro.description}</Styled.VideoDescDiv>
                </>
              )) }
            </Styled.VideoWrapDiv>
          : ''
          }

          { studentDetails.certificate && studentDetails.certificate.length > 0 ?
            <Styled.VideoWrapDiv>
              <Styled.HeadingP>Certifications</Styled.HeadingP>
              { studentDetails.certificate.map(pro => (
                <>
                  <Styled.NameDiv>{pro.cert_name}</Styled.NameDiv>
                  { isValid(pro.organization) ?
                    <Styled.SubnameDiv>{pro.organization}</Styled.SubnameDiv>
                  : ''
                  }

                  { isValid(pro.start_date) ?
                    <Styled.SubnameDiv>
                      {`Issued ${moment(pro.start_date).format("MMM YYYY")} - ${isValid(pro.end_date) ? moment(pro.end_date).format("MMM YYYY") : 'No expiration date'}`}
                    </Styled.SubnameDiv>
                  : ''
                  }

                  { isValid(pro.cert_url) ?
                    <CoffeeeButton onClick={() => setShowCertificate(true)} text="View Certificate"/>                  : ''
                  }

                  <Modal
                    width="60vw"
                    bodyStyle={{ maxHeight: "72vh", overflow: "scroll" }}
                    open={showCertificate}
                    header={false}
                    footer={false}
                    onCancel={() => setShowCertificate(false)}
                  >
                    <Styled.CertificateImg src={pro.cert_url} />
                  </Modal>
                </>
              )) }
            </Styled.VideoWrapDiv>
          : ''
          }

          { isValid(studentDetails.resume) ?
            <Styled.VideoWrapDiv>
              <Styled.HeadingP>Resume</Styled.HeadingP>
              <Styled.ResumeA href={studentDetails.resume} target="_blank">
                <img src="/pdf-icon.svg" />
                <div>{studentDetails.resume ? decodeURIComponent(studentDetails.resume.substring(studentDetails.resume.lastIndexOf("/") + 1)) : ""}</div>
              </Styled.ResumeA>
            </Styled.VideoWrapDiv>
          : ''
          }

        </Styled.InnerContainerDiv>
      </Modal>

      <CoffeeeButton
        style={style}
        onClick={getCandidateDetails}
        theme={theme}
        loading={loading}
        text="View Profile"
        type="TERTIARY"
      />

    </>
  );
};

export default StudentDetailsCardWithVideos;
